import { TextAlign } from '@/src/types/common';
import _, { get } from 'lodash';
import { validateLink } from 'src/constrains/LinkLibrary/tools';
import {
  validateCarouselSetting,
  validatePosterCarouselSetting,
} from 'src/constrains/ResponsiveLayerEditor/ImagePosterEdit/tool';
import {
  convertSpecificError,
  errorsCompare,
  getCurrentDisplayError as _getCurrentDisplayError,
  onContentErrorHooks as _onContentErrorHooks,
  useErrorOnChange,
  useErrorOnChange2,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from 'src/error/code';
import {
  separateSymbol,
  //blackColor,
  whiteColor,
} from 'src/tools/constant';
import { randomNumber } from 'src/tools/helper';
import { EnumLinkType } from 'src/types/common/linkType';
import {
  EBackgroundType,
  ELayerType,
  EModuleWidth,
  EnumCarouselOptions,
  EnumModuleType,
  EnumScrollType,
  EnumSeoTag,
  EOverflowOption,
  EPositionOption,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveContentPageToShow,
  EResponsivePosterGap,
  EResponsivePosterType,
  EResponsiveProductToShow,
  EResponsiveResizingOption,
} from 'src/types/common/module';
import {
  EPreviewSize,
  SubscriptionLayoutOption,
  //WebSiteSubType,
} from 'src/types/common/SalesChannel';
export { EnumSeoTag, EnumScrollType, EnumCarouselOptions, EnumModuleType };
export { EnumLinkType };
//=====================
export {
  useErrorOnChange,
  generateProductList,
  generateProductGrid,
  generateText,
  generateLongCanvas,
  generatePoster,
  generateCarousel,
  generateProductCarousel,
  generateLinkImg,
  ProductCarouselAmountOptions,
  PostOptions,
  ProductCarouselScrollOptions,
  staticModuleType,
  optionsToNum,
  CarouselOptions,
  hasItemList,
  GridOptions,
  SeoTag,
  listPropertyName,
  moduleHeaderProperties,
  validation,
  linkModulesContentValidation,
  modulesAmountValidation,
  useErrorOnChange2,
  errorsCompare,
  getCurrentDisplayError,
  onContentErrorHooks,
  initContentBody,
  initContentError,
  generateBody,
  linkImgValidation,
  linkValidation,
  generateNewContent,
  moduleTypeHasChanged,
  generateSubscription,
  errKeys,
  generateArticleCarousel,
  generateArticleList,
  generateNewContentImg,
  generateVideo,
  generateResponsiveImageCarousel,
  generateResponsiveImage,
  generateResponsiveImageLayer,
  generateResponsiveProductCarousel,
  generateResponsiveContentPageCarousel,
  validateImageLayer,
  layerErrorKey,
  generateResponsiveSubscription,
  generateResponsiveTextEditor,
  generateResponsivePoster,
  generateResponsiveProductGrid,
  generateResponsiveProductTab,
  generateResponsivePosterTab,
  generateTabProduct,
  generateTabPoster,
  responsivePosterTypeDict,
  generateResponsiveContentTab,
  generateTabContent,
  tabErrorNameGenerator,
  generateResponsiveTextContent,
};

//=============================================//

const emailField = {
  field: {
    type: 'Input',
    name: 'Email',
    fieldType: 'Email',
    uuid: 'ecbf4710-5a18-47a5-85e8-32734528acb8',
  },
  draggableId: 'Email',
  required: true,
  placeholder: 'Email',
  // hideDelete: true,
};

const linkModuleNone = {
  action: null,
  item: { hasError: false },
  label: 'None',
  linkType: 'None',
  uuid: null,
};

const responsivePosterTypeDict = {
  [EResponsivePosterType.ONE]: 1,
  [EResponsivePosterType.FIVE]: 5,
  [EResponsivePosterType.FOUR]: 4,
  [EResponsivePosterType.SIX]: 6,
  [EResponsivePosterType.THREE]: 3,
  [EResponsivePosterType.TWO_1_1]: 2,
  [EResponsivePosterType.TWO_1_2]: 2,
  [EResponsivePosterType.TWO_2_1]: 2,
};

const responsiveProductTypeDict = {
  [EResponsiveProductToShow.One]: 1,
  [EResponsiveProductToShow.Two]: 2,
  [EResponsiveProductToShow.TwoLandscape]: 2,
  [EResponsiveProductToShow.TwoPortrait]: 2,
  [EResponsiveProductToShow.Three]: 3,
  [EResponsiveProductToShow.Four]: 4,
  [EResponsiveProductToShow.Five]: 5,
  [EResponsiveProductToShow.Six]: 6,
};

const responsiveContentPageTypeDict = {
  [EResponsiveContentPageToShow.One]: 1,
  [EResponsiveContentPageToShow.Two]: 2,
  [EResponsiveContentPageToShow.TwoLandscape]: 2,
  [EResponsiveContentPageToShow.TwoPortrait]: 2,
  [EResponsiveContentPageToShow.Three]: 3,
  [EResponsiveContentPageToShow.Four]: 4,
  [EResponsiveContentPageToShow.Five]: 5,
  [EResponsiveContentPageToShow.Six]: 6,
};

const moduleHeaderProperties = {
  [EnumModuleType.Carousel]: {
    img: null,
    name: 'Carousel',
  },
  [EnumModuleType.LongCanvas]: {
    img: null,
    name: 'Long Canvas',
  },
  [EnumModuleType.Poster]: { img: null, name: 'Poster' },
  [EnumModuleType.ProductCarousel]: { img: null, name: 'Carousel' },
  [EnumModuleType.ProductGrid]: { img: null, name: 'Grid Display' },
  [EnumModuleType.ProductList]: { img: null, name: 'List' },
  [EnumModuleType.Text]: { img: null, name: 'Text' },
  [EnumModuleType.Edm]: { img: null, name: 'EDM (Electronic Direct Mail)' },
  [EnumModuleType.Subscription]: { img: null, name: 'Subscription' },
  [EnumModuleType.ArticleCarousel]: { img: null, name: 'Carousel' },
  [EnumModuleType.ArticleList]: { img: null, name: 'Carousel' },
  [EnumModuleType.Video]: { img: null, name: 'Video' },
  [EnumModuleType.ResponsiveImageCarousel]: { img: null, name: 'Carousel' },
  [EnumModuleType.ResponsiveContentCarousel]: { img: null, name: 'Carousel' },
  [EnumModuleType.ResponsiveProductCarousel]: { img: null, name: 'Carousel' },
  [EnumModuleType.ResponsiveSubscription]: { img: null, name: 'Subscription' },
  [EnumModuleType.ResponsivePoster]: { img: null, name: 'Poster' },
  [EnumModuleType.ResponsiveProductGrid]: { img: null, name: 'Grid' },
  [EnumModuleType.ResponsiveContentGrid]: { img: null, name: 'Grid' },
  [EnumModuleType.ResponsiveText]: { img: null, name: 'Text' },
  [EnumModuleType.ResponsiveProductTab]: { img: null, name: 'Tab' },
  [EnumModuleType.ResponsiveContentTab]: { img: null, name: 'Tab' },
  [EnumModuleType.ResponsivePosterTab]: { img: null, name: 'Tab' },
};

const staticModuleType = [EnumModuleType.Edm];

const hasItemList = [
  EnumModuleType.Carousel,
  EnumModuleType.LongCanvas,
  EnumModuleType.Poster,
  EnumModuleType.ProductCarousel,
  EnumModuleType.ProductGrid,
  EnumModuleType.ProductList,
  EnumModuleType.Subscription,
  EnumModuleType.ArticleCarousel,
  EnumModuleType.ArticleList,
  EnumModuleType.ResponsiveImageCarousel,
  EnumModuleType.ResponsiveProductCarousel,
  EnumModuleType.ResponsiveContentCarousel,
  EnumModuleType.ResponsiveSubscription,
  EnumModuleType.ResponsivePoster,
  EnumModuleType.ResponsiveProductGrid,
  EnumModuleType.ResponsiveContentGrid,
  EnumModuleType.ResponsiveProductTab,
  EnumModuleType.ResponsiveContentTab,
  EnumModuleType.ResponsivePosterTab,
  // EnumModuleType.Video,
];

enum EnumListPropertyName {
  linkModules = 'linkModules',
  products = 'products',
  tacs = 'tacs',
  fields = 'fields',
  configFieldsList = 'configFieldsList',
  images = 'images',
  contentPages = 'contentPages',
  tabs = 'tabs',
}

const listPropertyName = {
  [EnumModuleType.Carousel]: EnumListPropertyName.linkModules,
  [EnumModuleType.LongCanvas]: EnumListPropertyName.linkModules,
  [EnumModuleType.Poster]: EnumListPropertyName.linkModules,
  [EnumModuleType.ProductCarousel]: EnumListPropertyName.products,
  [EnumModuleType.ProductGrid]: EnumListPropertyName.products,
  [EnumModuleType.ProductList]: EnumListPropertyName.products,
  [EnumModuleType.Subscription]: [
    EnumListPropertyName.tacs,
    EnumListPropertyName.fields,
  ],
  [EnumModuleType.ArticleCarousel]: EnumListPropertyName.configFieldsList,
  [EnumModuleType.ArticleList]: EnumListPropertyName.configFieldsList,
  [EnumModuleType.ResponsiveImageCarousel]: EnumListPropertyName.images,
  [EnumModuleType.ResponsiveProductCarousel]: EnumListPropertyName.products,
  [EnumModuleType.ResponsiveContentCarousel]: EnumListPropertyName.contentPages,
  [EnumModuleType.ResponsiveSubscription]: [
    EnumListPropertyName.tacs,
    EnumListPropertyName.fields,
  ],
  [EnumModuleType.ResponsivePoster]: EnumListPropertyName.images,
  [EnumModuleType.ResponsiveProductGrid]: EnumListPropertyName.products,
  [EnumModuleType.ResponsiveContentGrid]: EnumListPropertyName.contentPages,
  [EnumModuleType.ResponsiveProductTab]: EnumListPropertyName.tabs,
  [EnumModuleType.ResponsivePosterTab]: EnumListPropertyName.tabs,
  [EnumModuleType.ResponsiveContentTab]: EnumListPropertyName.tabs,
};

const SeoTag = [
  { label: 'H1', value: EnumSeoTag.H1 },
  { label: 'H2', value: EnumSeoTag.H2 },
];

const GridOptions = [
  // { label: 'One in a row', value: EnumCarouselOptions.One },
  { label: 'Two in a row', value: EnumCarouselOptions.Two },
  { label: 'Three in a row', value: EnumCarouselOptions.Three },
];

const CarouselOptions = [
  { label: 'One Poster', value: EnumCarouselOptions.One },
  { label: '2 in 1', value: EnumCarouselOptions.Two },
];

const PostOptions = [
  { label: 'One Poster', value: EnumCarouselOptions.One },
  { label: '2 in 1', value: EnumCarouselOptions.Two },
  { label: '3 in 1', value: EnumCarouselOptions.Three },
  { label: '4 in 1', value: EnumCarouselOptions.Four },
  { label: '5 in 1', value: EnumCarouselOptions.Five },
];

const ProductCarouselScrollOptions = [
  {
    label: 'Smooth Scroll',
    value: EnumScrollType.Smooth,
  },
  {
    label: 'Paged Scroll',
    value: EnumScrollType.Paged,
  },
];

const ProductCarouselAmountOptions = [
  {
    label: 'One Product On Screen',
    value: EnumCarouselOptions.One,
  },
  {
    label: 'Two Products On Screen',
    value: EnumCarouselOptions.Two,
  },
  {
    label: 'Three Products On Screen',
    value: EnumCarouselOptions.Three,
  },
];

const optionsToNum = {
  [EnumCarouselOptions.Two]: 2,
  [EnumCarouselOptions.One]: 1,
  [EnumCarouselOptions.Three]: 3,
  [EnumCarouselOptions.Four]: 4,
  [EnumCarouselOptions.Five]: 5,
};

const contentPageExactNumberErr = {
  1: 999955,
  2: 999956,
  3: 999957,
  4: 999961,
  5: 999960,
  6: 999959,
};

const contentPageNumberErr = {
  1: 999936,
  2: 999937,
  3: 999938,
  4: 999941,
  5: 999940,
  6: 999939,
};

const productNumberErr = {
  1: 999949,
  2: 999950,
  3: 999951,
  4: 999954,
  5: 999953,
  6: 999952,
};

const productExactNumberErr = {
  1: 999942,
  2: 999943,
  3: 999944,
  4: 999947,
  5: 999946,
  6: 999945,
};

const defaultAutoPlay = {
  autoPlay: false,
  intervalTime: 3,
};

//=========================//
const generateTabPoster = (index?) => {
  return {
    draggableId: randomNumber(),
    title: `Tab ${index || 1}`,
    posterType: EResponsivePosterType.TWO_1_1,
    posters: [
      generateResponsiveImage(`Poster ${1}`),
      generateResponsiveImage(`Poster ${2}`),
    ],
  };
};

const generateTabProduct = (index?) => {
  return {
    draggableId: randomNumber(),
    title: `Tab ${index || 1}`,
    productToShow: EResponsiveProductToShow.TwoPortrait,
    buttonThemeUuid: null,
    products: [],
  };
};

const generateTabContent = (index?) => {
  return {
    draggableId: randomNumber(),
    title: `Tab ${index || 1}`,
    contentPagesToShow: EResponsiveContentPageToShow.TwoPortrait,
    contentPages: [],
  };
};

const generateTabStyle = () => {
  return {
    gapUnderTab: 12,
    regularTabColor: '#fff',
    activeTabColor: '#000',
  };
};

export const generateResponsiveText = () => {
  return {
    backgroundColor: '#fff',
    productNameColor: '#000',
    bodyTextColor: '#B9BCBF',
    listPriceColor: '#D20000',
    otherPriceColor: '#B9BCBF',
    subtitleColor: '#000',
    contentPageNameColor: '#000',
    contentPageSummaryColor: '#000',
  };
};

const generateResponsiveTextContent = () => {
  return {
    text: '',
    textBoxWidth: 1000,
    fontSizeMultiply: 120,
    textAlignment: TextAlign.LEFT,
    contentHasError: true,
  };
};

const generateLinkImg = (amount = 0) => {
  const _r = [];
  for (let i = 0; i < amount; i++) {
    _r.push({
      draggableId: randomNumber(),
      linkImage: null,
      uuid: null,
      linkType: EnumLinkType.None,
      label: 'None',
    });
  }
  return _r;
};

export const generateResponsiveModuleStyle = () => {
  return {
    topPadding: 16,
    bottomPadding: 16,
    marginToTop: 16,
    marginToBottom: 16,
    marginToLeft: 16,
    marginToRight: 16,
    fullWidth: false,
    backgroundType: EBackgroundType.NONE,
  };
};

const generateResponsiveImage = (name?) => {
  return {
    name: name || 'Image',
    image: null,
    imageLink: {
      ...linkModuleNone,
    },
    background: false,
    autoplayEnabled: false,
    mute: false,
    layers: [],
    draggableId: randomNumber(),
    isNew: true,
  };
};

const generateResponsiveImageLayer = () => {
  return {
    layerType: ELayerType.BUTTON,
    buttonThemeUuid: null,
    buttonText: 'Button',
    linkModule: null,
    marginToLeft: 0,
    marginToTop: 0,
    marginToBottom: 0,
    marginToRight: 0,
    marginToVCenter: 0,
    marginToHCenter: 0,
    hoverEffectUuid: null,
    entranceUuid: null,
    content: generateResponsiveTextContent(),
    image: null,
    draggableId: randomNumber(),
    positionOption: [EPositionOption.Center],
    imageWidth: 16,
    visible: true,
  };
};

const _commonProps = (type) => {
  return {
    draggableId: randomNumber(),
    visible: true,
    moduleName: moduleHeaderProperties[type].name,
  };
};

const generateCarousel = (amount = 0) => {
  const _r = [];
  for (let i = 0; i < amount; i++) {
    _r.push({
      initialStaticData: {
        moduleType: EnumModuleType.Carousel,
        posterType: EnumCarouselOptions.One,
        autoPlay: false,
        intervalTime: 3,
        ..._commonProps(EnumModuleType.Carousel),
      },
      initialDynamicData: generateLinkImg(1),
    });
  }
  return _r;
};

const generateNewContent = (type) => {
  const dic = {
    [EnumModuleType.Carousel]: generateCarousel1,
    [EnumModuleType.ProductCarousel]: generateProductCarousel,
    [EnumModuleType.Poster]: generatePoster,
    [EnumModuleType.LongCanvas]: generateLongCanvas,
    [EnumModuleType.Text]: generateText,
    [EnumModuleType.ProductGrid]: generateProductGrid,
    [EnumModuleType.ProductList]: generateProductList,
    [EnumModuleType.Subscription]: generateProductList,
    [EnumModuleType.ArticleCarousel]: generateArticleCarousel,
    [EnumModuleType.ArticleList]: generateArticleList,
    [EnumModuleType.ResponsiveProductCarousel]:
      generateResponsiveProductCarousel,
    [EnumModuleType.ResponsiveImageCarousel]: generateResponsiveImageCarousel,
    [EnumModuleType.ResponsiveContentCarousel]:
      generateResponsiveContentPageCarousel,
    [EnumModuleType.ResponsiveSubscription]: generateResponsiveSubscription,

    //generateResponsiveContentPageCarousel
    [EnumModuleType.ResponsivePoster]: generateResponsivePoster,
    [EnumModuleType.ResponsiveProductGrid]: generateResponsiveProductGrid,
    [EnumModuleType.ResponsiveContentGrid]: generateResponsiveContentGrid,
    [EnumModuleType.ResponsiveText]: generateResponsiveTextEditor,
    [EnumModuleType.ResponsivePosterTab]: generateResponsivePosterTab,
    [EnumModuleType.ResponsiveProductTab]: generateResponsiveProductTab,
    [EnumModuleType.ResponsiveContentTab]: generateResponsiveContentTab,
    //generateResponsivePoster //
  };
  if (dic[type]) {
    return dic[type]();
  } else {
    return {
      initialStaticData: {
        moduleType: type,
      },
      initialDynamicData: [],
    };
  }
};

const moduleTypeHasChanged = (type) => {
  const { initialStaticData, initialDynamicData } = generateNewContent(type);

  const { draggableId, visible, moduleName, ...rest } = initialStaticData;

  return {
    staticData: rest,
    dynamicData: initialDynamicData,
    _test: {
      draggableId,
      visible,
      moduleName,
    },
  };
};

const generateCarousel1 = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.Carousel,
      posterType: EnumCarouselOptions.One,
      autoPlay: false,
      intervalTime: 3,
      ..._commonProps(EnumModuleType.Carousel),
    },
    initialDynamicData: generateLinkImg(1),
  };
};

const generateProductCarousel = () => {
  return {
    initialStaticData: {
      scrollType: EnumScrollType.Smooth,
      autoPlay: false,
      intervalTime: 3,
      productToShow: EnumCarouselOptions.One,
      moduleType: EnumModuleType.ProductCarousel,
      ..._commonProps(EnumModuleType.ProductCarousel),
    },
    initialDynamicData: [],
  };
};

const generatePoster = () => {
  return {
    initialStaticData: {
      scrollType: EnumScrollType.Smooth,
      posterType: EnumCarouselOptions.One,
      moduleType: EnumModuleType.Poster,
      ..._commonProps(EnumModuleType.Poster),
    },
    initialDynamicData: generateLinkImg(1),
  };
};

const generateLongCanvas = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.LongCanvas,
      ..._commonProps(EnumModuleType.LongCanvas),
    },
    initialDynamicData: generateLinkImg(1),
  };
};

const generateText = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.Text,
      backgroundColor: '#FFFFFF',
      textColor: '#000000',
      header: '',
      content: '',
      h1TagEnabled: '',
      margin: {
        top: '32',
        bottom: '32',
        left: '24',
        right: '24',
      },
      seoTag: EnumSeoTag.H1,
      ..._commonProps(EnumModuleType.Text),
    },
  };
};

const generateResponsiveTextEditor = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveText,
      content: generateResponsiveTextContent(),
      moduleStyle: generateResponsiveModuleStyle(),
      h1TagEnabled: false,
      ..._commonProps(EnumModuleType.ResponsiveText),
    },
  };
};

const generateProductGrid = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ProductGrid,
      backgroundColor: '#000000',
      productToShow: EnumCarouselOptions.Two,
      ..._commonProps(EnumModuleType.ProductGrid),
    },
    initialDynamicData: [],
  };
};

const generateProductList = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ProductList,
      backgroundColor: '#000000',
      ..._commonProps(EnumModuleType.ProductList),
    },
    initialDynamicData: [],
  };
};

const generateVideo = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.Video,
      video: null,
      enableAutoPlay: false,
      enableMute: false,
      ..._commonProps(EnumModuleType.Video),
    },
  };
};

const generateResponsiveSubscription = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveSubscription,
      layoutOption: SubscriptionLayoutOption.ONE_COLUMN,
      text: '',
      submitButtonText: 'Submit',
      buttonThemeUuid: null,
      moduleStyle: generateResponsiveModuleStyle(),
      subscriptionFormStyle: {
        outlineColor: '#B9BCBF',
        tacTextAndIconColor: '#ffffff',
      },
      animation: { entranceUuid: null, hoverEffectUuid: null },
      fontSizeMultiply: 100,
      textAlignment: TextAlign.LEFT,
      ..._commonProps(EnumModuleType.ResponsiveSubscription),
    },
    initialDynamicData: {
      fields: [emailField],
      tacs: [],
    },
  };
};

const generateSubscription = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.Subscription,
      title: '关注我们',
      description: '',
      backgroundColor: '#fff',
      textColor: '#000',
      buttonStyle: { backgroundColor: '#000', textColor: '#fff', text: '提交' },
      ..._commonProps(EnumModuleType.Subscription),
    },
    initialDynamicData: {
      fields: [emailField],
      tacs: [],
    },
  };
};

const generateNewContentImg = () => {
  return {
    draggableId: randomNumber(),
    image: null,
    contentPage: null,
    summary: '',
    subtitle: '',
  };
};

const generateArticleCarousel = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ArticleCarousel,
      scrollType: EnumScrollType.Paged,
      ...defaultAutoPlay,
      titleTextColor: whiteColor,
      ..._commonProps(EnumModuleType.ArticleCarousel),
    },
    initialDynamicData: [generateNewContentImg()],
  };
};

const generateArticleList = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ArticleList,
      titleTextColor: whiteColor,
      ..._commonProps(EnumModuleType.ArticleList),
    },
    initialDynamicData: [generateNewContentImg()],
  };
};

const generateResponsivePoster = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsivePoster,
      moduleWidth: EModuleWidth.NONE,
      posterGap: EResponsivePosterGap.NONE,
      posterType: EResponsivePosterType.ONE,
      moduleStyle: generateResponsiveModuleStyle(),
      resizingOption: EResponsiveResizingOption.FIXED,
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      ..._commonProps(EnumModuleType.ResponsivePoster),
    },
    initialDynamicData: [generateResponsiveImage(`Poster ${1}`)],
  };
};

const generateResponsiveImageCarousel = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveImageCarousel,
      moduleWidth: EModuleWidth.NONE,
      autoPlay: false,
      intervalTime: 3,
      moduleStyle: generateResponsiveModuleStyle(),
      resizingOption: EResponsiveResizingOption.FIXED,
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      ..._commonProps(EnumModuleType.ResponsiveImageCarousel),
    },
    initialDynamicData: [],
  };
};

const generateResponsiveProductCarousel = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveProductCarousel,
      moduleWidth: EModuleWidth.NONE,
      autoPlay: false,
      intervalTime: 3,
      leaveGap: false,
      scrollOut: 1,
      actionButtonTheme: null,
      productToShow: EResponsiveProductToShow.One,
      moduleText: generateResponsiveText(),

      moduleStyle: generateResponsiveModuleStyle(),
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      ..._commonProps(EnumModuleType.ResponsiveProductCarousel),
    },
    initialDynamicData: [],
  };
};

const generateResponsiveContentPageCarousel = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveContentCarousel,
      moduleWidth: EModuleWidth.NONE,
      autoPlay: false,
      intervalTime: 3,
      leaveGap: false,
      scrollOut: 1,
      actionButtonTheme: null,
      contentPagesToShow: EResponsiveContentPageToShow.One,
      moduleText: generateResponsiveText(),
      moduleStyle: generateResponsiveModuleStyle(),
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      ..._commonProps(EnumModuleType.ResponsiveContentCarousel),
    },
    initialDynamicData: [],
  };
};

const generateResponsiveProductGrid = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveProductGrid,
      overflowOption: EOverflowOption.Carousel,
      moduleWidth: EModuleWidth.WIDE,
      leaveGap: false,
      actionButtonTheme: null,
      productToShow: EResponsiveProductToShow.One,
      moduleText: generateResponsiveText(),
      moduleStyle: generateResponsiveModuleStyle(),
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      ..._commonProps(EnumModuleType.ResponsiveProductGrid),
    },
    initialDynamicData: [],
  };
};

const generateResponsiveContentGrid = () => {
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveContentGrid,
      moduleWidth: EModuleWidth.WIDE,
      overflowOption: EOverflowOption.Carousel,
      leaveGap: false,
      contentPagesToShow: EResponsiveContentPageToShow.One,
      moduleText: generateResponsiveText(),
      moduleStyle: generateResponsiveModuleStyle(),
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      ..._commonProps(EnumModuleType.ResponsiveContentGrid),
    },
    initialDynamicData: [],
  };
};

const generateResponsiveProductTab = () => {
  //generateTabProduct
  const product = generateTabProduct();
  const draggableId = product.draggableId;
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveProductTab,
      moduleWidth: EModuleWidth.WIDE,
      overflowOption: EOverflowOption.AnotherLine,
      leaveGap: false,
      moduleStyle: generateResponsiveModuleStyle(),
      moduleText: generateResponsiveText(),
      tabStyle: generateTabStyle(),
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      selectedTab: draggableId,
      ..._commonProps(EnumModuleType.ResponsiveProductTab),
    },
    initialDynamicData: [product],
  };
};

const generateResponsiveContentTab = () => {
  //generateTabProduct
  const contentPage = generateTabContent();
  const draggableId = contentPage.draggableId;
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsiveContentTab,
      moduleWidth: EModuleWidth.WIDE,
      overflowOption: EOverflowOption.AnotherLine,
      leaveGap: false,
      moduleStyle: generateResponsiveModuleStyle(),
      moduleText: generateResponsiveText(),
      tabStyle: generateTabStyle(),
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      selectedTab: draggableId,
      ..._commonProps(EnumModuleType.ResponsiveContentTab),
    },
    initialDynamicData: [contentPage],
  };
};

const generateResponsivePosterTab = () => {
  const tab = generateTabPoster();
  const draggableId = tab.draggableId;
  return {
    initialStaticData: {
      moduleType: EnumModuleType.ResponsivePosterTab,
      moduleWidth: EModuleWidth.WIDE,
      posterGap: EResponsivePosterGap.NONE,
      resizingOption: EResponsiveResizingOption.FIXED,
      overflowOption: EOverflowOption.AnotherLine,
      moduleStyle: generateResponsiveModuleStyle(),
      tabStyle: generateTabStyle(),
      animation: { hoverEffectUuid: null, entranceUuid: null },
      switcherType: EResponsiveCarouselModuleSwitcherType.ModuleStyle,
      selectedTab: draggableId,
      ..._commonProps(EnumModuleType.ResponsivePosterTab),
    },
    initialDynamicData: [tab],
  };
};

//=============================

//==validation==========
const errKeys = {
  linkImage: 'linkImageError',
  linkType: 'linkTypeError',
  general: {
    contentPageInvalid: 'contentPageInvalid',
    contentPage: 'contentPage',
    image: 'image',
    subtitle: 'subtitle',
    summary: 'summary',
    contentPages: 'contentPages',
  },
  [EnumModuleType.Subscription]: {
    subscriptionTitle: 'subscriptionTitle',
    buttonTitle: 'buttonTitle',
    termsAndConditions: 'termsAndConditions',
  },
  [EnumModuleType.ArticleCarousel]: {
    contentPageInvalid: 'contentPageInvalid',
    contentPage: 'contentPage',
    image: 'image',
    subtitle: 'subtitle',
    summary: 'summary',
    contentPages: 'contentPages',
  },
  [EnumModuleType.ArticleList]: {
    contentPageInvalid: 'contentPageInvalid',
    contentPage: 'contentPage',
    image: 'image',
    subtitle: 'subtitle',
    summary: 'summary',
    contentPages: 'contentPages',
  },
  [EnumModuleType.Video]: {
    video: 'contentPage',
  },
  [EnumModuleType.ResponsiveImageCarousel]: {
    imageLayers: 'imageLayers',
  },
  [EnumModuleType.ResponsiveContentCarousel]: {
    contentPageToShow: 'contentPageToShow',
    contentPageToShowMismatch: 'contentPageToShowMismatch',
    contentPageInvalid: 'contentPageInvalid',
    contentPage: 'contentPage',
    image: 'image',
    subtitle: 'subtitle',
    summary: 'summary',
    contentPages: 'contentPages',
  },
  [EnumModuleType.ResponsiveProductCarousel]: {
    productToShow: 'productToShow',
    productToShowMismatch: 'productToShowMismatch',
  },
  [EnumModuleType.ResponsivePoster]: {
    imageLayers: 'imageLayers',
  },
  [EnumModuleType.ResponsiveProductGrid]: {
    productToShow: 'productToShow',
    productToShowMismatch: 'productToShowMismatch',
  },
  [EnumModuleType.ResponsiveContentGrid]: {
    contentPageToShow: 'contentPageToShow',
    contentPageToShowMismatch: 'contentPageToShowMismatch',
    contentPageInvalid: 'contentPageInvalid',
    contentPage: 'contentPage',
    image: 'image',
    subtitle: 'subtitle',
    summary: 'summary',
    contentPages: 'contentPages',
  },
  [EnumModuleType.ResponsiveSubscription]: {
    layoutOption: 'layoutOption',
    submitButtonText: 'submitButtonText',
    buttonThemeUuid: 'buttonThemeUuid',
    fields: 'fields',
    topPadding: 'topPadding',
    bottomPadding: 'bottomPadding',
    subscriptionFormStyle: 'subscriptionFormStyle',
    entranceUuid: 'entranceUuid',
    hoverEffectUuid: 'hoverEffectUuid',
    fontSizeMultiply: 'fontSizeMultiply',
    termsAndConditions: 'termsAndConditions',
  },
  [EnumModuleType.ResponsiveText]: {
    text: 'text',
    textBoxWidth: 'textBoxWidth',
    topPadding: 'topPadding',
    bottomPadding: 'bottomPadding',
  },
  [EnumModuleType.ResponsiveProductTab]: {
    productAmount: 'productAmount',
    tabName: 'tabName',
  },
  [EnumModuleType.ResponsiveContentTab]: {
    contentPageInvalid: 'contentPageInvalid',
    contentPage: 'contentPage',
    contentPages: 'contentPages',
    image: 'image',
    subtitle: 'subtitle',
    summary: 'summary',
    tabName: 'tabName',
    contentPagesAmount: 'contentPagesAmount',
  },
  [EnumModuleType.ResponsivePosterTab]: {
    tabName: 'tabName',
    imageLayers: 'imageLayers',
    image: 'image',
  },
};

const tabErrorNameGenerator = (tabId, dragItemId, key) => {
  return `${tabId}${dragItemId}${key}`;
};

const validation = (data, validationProps) => {
  //const { siteStyle, breakpoint } = validationProps;
  const contentPages = get(validationProps, 'contentPages');

  // const siteStyle =
  //   get(validationProps, 'siteStyle') || WebSiteSubType.NativeMobile;
  const breakpoint = get(validationProps, 'breakpoint') || EPreviewSize.WIDE;
  const { staticData: staticConfig, dynamicData: dynamicConfig } = data;
  const isConvertible = breakpoint && breakpoint !== EPreviewSize.WIDE;
  const { moduleType } = staticConfig;
  const list = Array.isArray(dynamicConfig) ? dynamicConfig : [];
  const specificErr = {};

  switch (moduleType) {
    case EnumModuleType.Carousel: {
      const { autoPlay, intervalTime, posterType } = staticConfig;
      const amount = optionsToNum[posterType];
      specificErr['posterTypeError'] = [];
      specificErr['intervalTimeError'] = [];
      if (!posterType) {
        specificErr['posterTypeError'].push(errCodesMap['104310']);
      }
      if (autoPlay && intervalTime < 1) {
        specificErr['intervalTimeError'].push(errCodesMap['104311']);
      }
      const _amountCode = modulesAmountValidation(
        amount,
        list,
        errCodesMap['104337'] || '',
      );
      const _contentCode = linkModulesContentValidation(list);
      const { hasError, moduleError } = _contentCode;
      const a = {
        hasError: _amountCode.length > 0 || hasError,
        specificError: { ...moduleError, ...specificErr },
        generalError: _amountCode,
      };

      return a;
    }
    case EnumModuleType.ProductCarousel: {
      const { scrollType, autoPlay, intervalTime, productToShow } =
        staticConfig;
      // console.log('ProductCarousel,', staticConfig);
      // console.log('ProductCarousel,list,', list);
      specificErr['intervalTimeError'] = [];
      if (scrollType === EnumScrollType.Paged && autoPlay && intervalTime < 1) {
        specificErr['intervalTimeError'].push(errCodesMap['104311']);
      }
      if (scrollType === EnumScrollType.Paged) {
        const amount =
          productToShow === EnumCarouselOptions.One
            ? 3
            : optionsToNum[productToShow];
        const _amountCode = modulesAmountValidation(
          amount,
          list,
          errCodesMap['104325'] || '',
          true,
        );

        return {
          hasError:
            _amountCode.length > 0 ||
            convertSpecificError(specificErr).length > 0,
          specificError: specificErr,
          generalError: _amountCode,
        };
      }
      if (scrollType === EnumScrollType.Smooth) {
        const amount = optionsToNum[productToShow] + 1;
        const _amountCode = modulesAmountValidation(
          amount,
          list,
          errCodesMap['104325'] || '',
          true,
          true,
        );

        return {
          hasError:
            _amountCode.length > 0 ||
            convertSpecificError(specificErr).length > 0,
          specificError: specificErr,
          generalError: _amountCode,
        };
      }
    }
    case EnumModuleType.Poster: {
      const _contentCode = linkModulesContentValidation(list);
      const { hasError, moduleError } = _contentCode;

      return {
        hasError,
        specificError: moduleError,
        generalError: [],
      };
    }
    case EnumModuleType.LongCanvas: {
      const _contentCode = linkModulesContentValidation(list);
      const { hasError, moduleError } = _contentCode;
      const _amountCode = modulesAmountValidation(
        1,
        list,
        errCodesMap['104337'] || '',
      );
      return {
        hasError: _amountCode.length > 0 || hasError,
        specificError: moduleError,
        generalError: _amountCode,
      };
    }
    case EnumModuleType.Text: {
      return {
        hasError: false,
        specificError: {},
        generalError: [],
      };
    }
    case EnumModuleType.ResponsiveText: {
      const { content, moduleStyle } = staticConfig;
      const generalError = [];
      switch (breakpoint) {
        case EPreviewSize.WIDE: {
          if (!content?.text) {
            generalError.push(errCodesMap['999999']);
          }
          specificErr[errKeys[EnumModuleType.ResponsiveText].topPadding] = [];
          if (!moduleStyle?.topPadding) {
            specificErr[errKeys[EnumModuleType.ResponsiveText].topPadding].push(
              errCodesMap['999978'],
            );
          }
          specificErr[errKeys[EnumModuleType.ResponsiveText].bottomPadding] =
            [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveText].bottomPadding
            ].push(errCodesMap['999978']);
          }
          specificErr[errKeys[EnumModuleType.ResponsiveText].textBoxWidth] = [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveText].textBoxWidth
            ].push(errCodesMap['999978']);
          }
          return {
            hasError:
              generalError.length > 0 ||
              convertSpecificError(specificErr).length > 0,
            specificError: specificErr,
            generalError,
          };
        }
        case EPreviewSize.TABLET: {
          specificErr[errKeys[EnumModuleType.ResponsiveText].topPadding] = [];
          if (!moduleStyle?.topPadding) {
            specificErr[errKeys[EnumModuleType.ResponsiveText].topPadding].push(
              errCodesMap['999978'],
            );
          }
          specificErr[errKeys[EnumModuleType.ResponsiveText].bottomPadding] =
            [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveText].bottomPadding
            ].push(errCodesMap['999978']);
          }
          specificErr[errKeys[EnumModuleType.ResponsiveText].textBoxWidth] = [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveText].textBoxWidth
            ].push(errCodesMap['999978']);
          }
          return {
            hasError:
              generalError.length > 0 ||
              convertSpecificError(specificErr).length > 0,
            specificError: specificErr,
            generalError,
          };
        }
        case EPreviewSize.MOBILE: {
          specificErr[errKeys[EnumModuleType.ResponsiveText].topPadding] = [];
          if (!moduleStyle?.topPadding) {
            specificErr[errKeys[EnumModuleType.ResponsiveText].topPadding].push(
              errCodesMap['999978'],
            );
          }
          specificErr[errKeys[EnumModuleType.ResponsiveText].bottomPadding] =
            [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveText].bottomPadding
            ].push(errCodesMap['999978']);
          }
          specificErr[errKeys[EnumModuleType.ResponsiveText].textBoxWidth] = [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveText].textBoxWidth
            ].push(errCodesMap['999978']);
          }
          return {
            hasError:
              generalError.length > 0 ||
              convertSpecificError(specificErr).length > 0,
            specificError: specificErr,
            generalError,
          };
        }
      }
    }
    case EnumModuleType.ProductGrid: {
      const { productToShow } = staticConfig;
      const amount = optionsToNum[productToShow];
      const _amountCode = modulesAmountValidation(
        amount,
        list,
        errCodesMap['104325'],
      );
      return {
        hasError: _amountCode.length > 0,
        specificError: {},
        generalError: _amountCode,
      };
    }
    case EnumModuleType.ProductList: {
      const { productToShow } = staticConfig;
      const amount = optionsToNum[productToShow];
      const _amountCode = modulesAmountValidation(
        amount,
        list,
        errCodesMap['104325'],
        true,
      );
      return {
        hasError: _amountCode.length > 0,
        specificError: {},
        generalError: _amountCode,
      };
    }
    case EnumModuleType.Video: {
      const videoUuid = _.get(staticConfig, 'video.uuid');
      const specificErr = {};
      if (!videoUuid) {
        specificErr[errKeys[EnumModuleType.Video].video] = [
          errCodesMap['999980'],
        ];
      }
      return {
        hasError: convertSpecificError(specificErr).length > 0,
        specificError: specificErr,
        generalError: [],
      };
    }
    case EnumModuleType.Subscription: {
      // console.log('siteStyle', siteStyle);
      // console.log('breakpoint', breakpoint);
      // console.log('staticConfig', staticConfig);
      // console.log('dynamicConfig', dynamicConfig);
      const { title: subTitle, buttonStyle } = staticConfig;
      const { text: btnTitle } = buttonStyle || {};
      const { fields, tacs } = dynamicConfig;

      const generalError = [];

      if (fields.length < 1) {
        generalError.push(errCodesMap['999990']);
      }
      specificErr[errKeys[EnumModuleType.Subscription].subscriptionTitle] = [];
      if (!subTitle) {
        specificErr[
          errKeys[EnumModuleType.Subscription].subscriptionTitle
        ].push(errCodesMap['999993']);
      }
      specificErr[errKeys[EnumModuleType.Subscription].buttonTitle] = [];
      if (!btnTitle) {
        specificErr[errKeys[EnumModuleType.Subscription].buttonTitle].push(
          errCodesMap['999993'],
        );
      }
      specificErr[errKeys[EnumModuleType.Subscription].termsAndConditions] = [];
      const att = (tacs || []).reduce((pre, now) => {
        const { consentAttributes } = now || {};
        return [...pre, ...(consentAttributes || [])];
      }, []);
      if (att.length < 1) {
        specificErr[
          errKeys[EnumModuleType.Subscription].termsAndConditions
        ].push(errCodesMap['999979']);
      }
      return {
        hasError:
          generalError.length > 0 ||
          convertSpecificError(specificErr).length > 0,
        specificError: specificErr,
        generalError: generalError,
      };
    }
    case EnumModuleType.ArticleCarousel: {
      const { generalError, specificError } = contentImgListValidation({
        type: EnumModuleType.ArticleCarousel,
        list,
        contentPages,
      });
      return {
        hasError:
          generalError.length > 0 ||
          convertSpecificError(specificError).length > 0,
        specificError: specificError,
        generalError: generalError,
      };
    }
    case EnumModuleType.ResponsiveSubscription: {
      const {
        layoutOption,
        text,
        submitButtonText,
        // buttonThemeUuid,
        moduleStyle,
        // animation,
      } = staticConfig;
      const { fields, tacs } = dynamicConfig;

      switch (breakpoint) {
        case EPreviewSize.WIDE: {
          const generalError = [];
          if (fields.length < 1) {
            generalError.push(errCodesMap['999976']);
            // specificErr[
            //   errKeys[EnumModuleType.ResponsiveSubscription].fields
            // ].push(errCodesMap['999990']);
          }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].termsAndConditions
          ] = [];
          const att = (tacs || []).reduce((pre, now) => {
            const { consentAttributes } = now || {};
            return [...pre, ...(consentAttributes || [])];
          }, []);
          if (att.length < 1) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].termsAndConditions
            ].push(errCodesMap['999979']);
          }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].layoutOption
          ] = [];
          if (!layoutOption) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].layoutOption
            ].push(errCodesMap['999993']);
          }

          if (!text) {
            generalError.push(errCodesMap['999999']);
          }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].submitButtonText
          ] = [];
          if (!submitButtonText) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].submitButtonText
            ].push(errCodesMap['999999']);
          }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].buttonThemeUuid
          ] = [];
          // if (!buttonThemeUuid) {
          //   specificErr[
          //     errKeys[EnumModuleType.ResponsiveSubscription].buttonThemeUuid
          //   ].push(errCodesMap['999978']);
          // }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].topPadding
          ] = [];
          if (!moduleStyle?.topPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].topPadding
            ].push(errCodesMap['999978']);
          }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].bottomPadding
          ] = [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].bottomPadding
            ].push(errCodesMap['999978']);
          }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].entranceUuid
          ] = [];
          // if (!animation?.entranceUuid) {
          //   specificErr[
          //     errKeys[EnumModuleType.ResponsiveSubscription].entranceUuid
          //   ].push(errCodesMap['999978']);
          // }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].hoverEffectUuid
          ] = [];
          // if (!animation?.hoverEffectUuid) {
          //   specificErr[
          //     errKeys[EnumModuleType.ResponsiveSubscription].hoverEffectUuid
          //   ].push(errCodesMap['999978']);
          // }

          return {
            hasError:
              generalError.length > 0 ||
              convertSpecificError(specificErr).length > 0,
            specificError: specificErr,
            generalError,
          };
        }
        case EPreviewSize.TABLET: {
          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].topPadding
          ] = [];
          if (!moduleStyle?.topPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].topPadding
            ].push(errCodesMap['999978']);
          }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].bottomPadding
          ] = [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].bottomPadding
            ].push(errCodesMap['999978']);
          }
          return {
            hasError: convertSpecificError(specificErr).length > 0,
            specificError: specificErr,
            generalError: [],
          };
        }

        case EPreviewSize.MOBILE: {
          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].topPadding
          ] = [];
          if (!moduleStyle?.topPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].topPadding
            ].push(errCodesMap['999978']);
          }

          specificErr[
            errKeys[EnumModuleType.ResponsiveSubscription].bottomPadding
          ] = [];
          if (!moduleStyle?.bottomPadding) {
            specificErr[
              errKeys[EnumModuleType.ResponsiveSubscription].bottomPadding
            ].push(errCodesMap['999978']);
          }
          return {
            hasError: convertSpecificError(specificErr).length > 0,
            specificError: specificErr,
            generalError: [],
          };
        }

        default: {
          return {
            hasError: false,
            specificError: {},
            generalError: [],
          };
        }
      }
    }
    case EnumModuleType.ArticleList: {
      const { generalError, specificError } = contentImgListValidation({
        type: EnumModuleType.ArticleList,
        list,
        contentPages,
      });
      return {
        hasError:
          generalError.length > 0 ||
          convertSpecificError(specificError).length > 0,
        specificError: specificError,
        generalError: generalError,
      };
    }
    case EnumModuleType.ResponsivePoster: {
      const layerError = list.reduce((pre, now) => {
        const { draggableId } = now;
        const { hasError } = validateImageEdit(now, {
          isPoster: true,
          breakpoint,
        });
        if (hasError) {
          return {
            ...pre,
            [`${errKeys.ResponsiveImageCarousel.imageLayers}${separateSymbol}${draggableId}`]:
              ['hasError'],
          };
        }
        return pre;
      }, {});
      const a = {
        hasError: convertSpecificError(layerError).length > 0,
        specificError: layerError,
        generalError: [],
      };

      return a;
    }
    case EnumModuleType.ResponsiveImageCarousel: {
      const layerError = list.reduce((pre, now) => {
        const { draggableId } = now;
        const { hasError } = validateImageEdit(now, {
          breakpoint,
          isPoster: true, // 图片编辑页面的类型
        });
        if (hasError) {
          return {
            ...pre,
            [`${errKeys.ResponsiveImageCarousel.imageLayers}${separateSymbol}${draggableId}`]:
              ['hasError'],
          };
        }
        return pre;
      }, {});

      const a = {
        hasError: convertSpecificError(layerError).length > 0,
        specificError: layerError,
        generalError: [],
      };

      return a;
    }
    case EnumModuleType.ResponsiveContentCarousel: {
      const { contentPagesToShow } = staticConfig;
      const g = [];
      const s = {
        [errKeys[EnumModuleType.ResponsiveContentCarousel]
          .contentPageToShowMismatch]: [],
      };
      const numOfList = (list || []).length;

      if (isConvertible) {
      } else {
        const correctNumber = responsiveContentPageTypeDict[contentPagesToShow];
        if (correctNumber <= numOfList) {
        } else {
          g.push(errCodesMap[contentPageNumberErr[correctNumber]]);
          s[
            errKeys[EnumModuleType.ResponsiveContentCarousel]
              .contentPageToShowMismatch
          ].push(errCodesMap['999990']);
        }
      }

      const { specificError: _s } = !isConvertible
        ? contentImgListValidation({
            contentPages,
            type: EnumModuleType.ResponsiveContentCarousel,
            list,
          })
        : { specificError: {} };

      const contentPagesHasError = convertSpecificError(_s).length > 0;

      const generalError = [...(g || [])];
      const specificError = {
        ...(s || {}),
        ...(_s || {}),
        [errKeys[EnumModuleType.ResponsiveContentCarousel].contentPages]:
          contentPagesHasError ? ['指数而已'] : [],
      };

      const a = {
        hasError:
          generalError.length > 0 ||
          convertSpecificError(specificError).length > 0,
        specificError: specificError,
        generalError: generalError,
      };

      return a;
    }
    case EnumModuleType.ResponsiveProductCarousel: {
      const numOfList = list.length;

      const productToShow = get(staticConfig, 'productToShow');

      const specificErr = {};
      const generalError = [];
      specificErr[
        errKeys[EnumModuleType.ResponsiveProductCarousel].productToShow
      ] = [];
      specificErr[
        errKeys[EnumModuleType.ResponsiveProductCarousel].productToShowMismatch
      ] = [];
      const correctNumber = responsiveProductTypeDict[productToShow];
      if (numOfList >= correctNumber) {
      } else {
        generalError.push(errCodesMap[productNumberErr[correctNumber]]);
        specificErr[
          errKeys[EnumModuleType.ResponsiveProductCarousel]
            .productToShowMismatch
        ].push(errCodesMap['999990']);
      }

      const a = {
        hasError:
          generalError.length > 0 ||
          convertSpecificError(specificErr).length > 0,
        specificError: specificErr,
        generalError: generalError,
      };

      return a;
    }
    case EnumModuleType.ResponsiveProductGrid: {
      //breakpoint
      const numOfList = list.length;

      const productToShow = get(staticConfig, 'productToShow');
      const dict = responsiveProductTypeDict;
      //errCodesMap['999990']
      const specificErr = {};
      const generalError = [];
      specificErr[errKeys[EnumModuleType.ResponsiveProductGrid].productToShow] =
        [];
      specificErr[
        errKeys[EnumModuleType.ResponsiveProductGrid].productToShowMismatch
      ] = [];
      if (!productToShow) {
        specificErr[
          errKeys[EnumModuleType.ResponsiveProductGrid].productToShow
        ].push(errCodesMap['999990']);
      } else {
        const correctNumber = dict[productToShow];

        if (isConvertible) {
        } else {
          if (correctNumber === numOfList) {
          } else {
            generalError.push(
              errCodesMap[productExactNumberErr[correctNumber]],
            );
            specificErr[
              errKeys[EnumModuleType.ResponsiveProductGrid]
                .productToShowMismatch
            ].push(productExactNumberErr[correctNumber]);
          }
        }
      }
      // console.log('specificErr', specificErr);
      // console.log('generalError', generalError);
      return {
        hasError:
          generalError.length > 0 ||
          convertSpecificError(specificErr).length > 0,
        specificError: specificErr,
        generalError: generalError,
      };
      // return a;
    }
    case EnumModuleType.ResponsiveContentGrid: {
      const numOfList = list.length;
      const contentPagesToShow = get(staticConfig, 'contentPagesToShow');
      const dict = responsiveContentPageTypeDict;
      //errCodesMap['999990']
      const specificErr = {};
      const generalError = [];
      specificErr[
        errKeys[EnumModuleType.ResponsiveContentGrid].contentPageToShow
      ] = [];
      specificErr[
        errKeys[EnumModuleType.ResponsiveContentGrid].contentPageToShowMismatch
      ] = [];
      specificErr[errKeys[EnumModuleType.ResponsiveContentGrid].contentPages] =
        [];
      if (!contentPagesToShow) {
        specificErr[
          errKeys[EnumModuleType.ResponsiveContentGrid].contentPageToShow
        ].push(errCodesMap['999990']);
      } else {
        if (isConvertible) {
        } else {
          const correctNumber = dict[contentPagesToShow];
          if (correctNumber === numOfList) {
          } else {
            generalError.push(
              errCodesMap[contentPageExactNumberErr[correctNumber]],
            );
            specificErr[
              errKeys[EnumModuleType.ResponsiveContentGrid]
                .contentPageToShowMismatch
            ].push(errCodesMap['999990']);
          }
        }
      }

      const { specificError: contentSpecific } = !isConvertible
        ? contentImgListValidation({
            contentPages,
            type: EnumModuleType.ResponsiveContentGrid,
            list,
          })
        : { specificError: {} };
      const contentPagesHasError =
        convertSpecificError(contentSpecific).length > 0;

      const _generalError = [...generalError];
      const _specificErr = {
        ...specificErr,
        ...contentSpecific,
        [errKeys[EnumModuleType.ResponsiveContentGrid].contentPages]:
          contentPagesHasError ? ['指数而已123'] : [],
      };
      //console.log('_specificErr123', _specificErr);
      // console.log('specificErr', specificErr);
      return {
        hasError:
          _generalError.length > 0 ||
          convertSpecificError(_specificErr).length > 0,
        specificError: _specificErr,
        generalError: _generalError,
      };
    }
    case EnumModuleType.ResponsivePosterTab: {
      const nameErrK = errKeys.ResponsivePosterTab.tabName;
      const imgErrK = errKeys.ResponsivePosterTab.image;
      const specificErr = list.reduce((pre, now) => {
        const draggableId = now.draggableId;
        const imagesK = (now.images || []).reduce((pre, now) => {
          const { draggableId: imageId } = now;
          const k = tabErrorNameGenerator(draggableId, imageId, imgErrK);
          return { ...pre, [k]: [] };
        }, {});
        const _nameK = `${draggableId}${nameErrK}`;
        return { ...pre, ...imagesK, [_nameK]: [] };
      }, {});
      list.forEach((tab) => {
        const { posters, draggableId, title } = tab;

        posters.forEach((image) => {
          const { draggableId: imgId } = image;
          const k = tabErrorNameGenerator(draggableId, imgId, imgErrK);
          const { hasError } = validateImageEdit(image, {
            isPoster: true,
            breakpoint,
          });
          if (hasError) {
            specificErr[k] = ['error'];
          }
        });

        if (!title) {
          specificErr[`${nameErrK}${draggableId}`] = [errCodesMap['999966']];
        }
      });
      //console.log('specificErr', specificErr);
      //tabErrorNameGenerator
      return {
        hasError: convertSpecificError(specificErr).length > 0,
        specificError: specificErr,
        generalError: [],
      };
    }
    case EnumModuleType.ResponsiveProductTab: {
      const k = errKeys.ResponsiveProductTab.productAmount;
      const nameErrK = errKeys.ResponsiveProductTab.tabName;
      const specificErr = list.reduce((pre, now) => {
        const draggableId = now.draggableId;
        const _k = `${draggableId}${k}`;
        const _nameK = `${draggableId}${nameErrK}`;
        return { ...pre, [_k]: [], [_nameK]: [] };
      }, {});
      list.forEach((tab) => {
        const { productToShow, products, draggableId, title } = tab;
        if (!title && !isConvertible) {
          specificErr[`${draggableId}${nameErrK}`] = [errCodesMap['999966']];
        }
        const requiredNum = responsiveProductTypeDict[productToShow];
        const _amountCode = isConvertible
          ? []
          : modulesAmountValidation(
              requiredNum,
              products,
              errCodesMap['999967'] || '',
              true,
            ) || [];

        const arr = specificErr[`${draggableId}${k}`];
        specificErr[`${draggableId}${k}`] = [...(arr || []), ..._amountCode];
      });
      //console.log('specificErr', specificErr);
      //tabErrorNameGenerator
      return {
        hasError: convertSpecificError(specificErr).length > 0,
        specificError: specificErr,
        generalError: [],
      };
    }
    case EnumModuleType.ResponsiveContentTab: {
      const amountErrK = errKeys.ResponsiveContentTab.contentPagesAmount;
      const nameErrK = errKeys.ResponsiveContentTab.tabName;
      const specificErr = list.reduce((pre, now) => {
        const draggableId = now.draggableId;
        const _k = `${draggableId}${amountErrK}`;
        const _nameK = `${draggableId}${nameErrK}`;
        const contentErrK = (now.contentPages || []).reduce((pre, now) => {
          const { draggableId: contentId } = now;
          const contentPageInvalid = tabErrorNameGenerator(
            draggableId,
            contentId,
            errKeys.ResponsiveContentTab.contentPageInvalid,
          );
          const contentPage = tabErrorNameGenerator(
            draggableId,
            contentId,
            errKeys.ResponsiveContentTab.contentPage,
          );
          const image = tabErrorNameGenerator(
            draggableId,
            contentId,
            errKeys.ResponsiveContentTab.image,
          );
          const subtitle = tabErrorNameGenerator(
            draggableId,
            contentId,
            errKeys.ResponsiveContentTab.subtitle,
          );
          const summary = tabErrorNameGenerator(
            draggableId,
            contentId,
            errKeys.ResponsiveContentTab.summary,
          );
          return {
            ...pre,
            [contentPage]: [],
            [image]: [],
            [subtitle]: [],
            [summary]: [],
            [contentPageInvalid]: [],
          };
        }, {});
        return { ...pre, [_k]: [], [_nameK]: [], ...contentErrK };
      }, {});
      const allContentPages = contentPages;
      list.forEach((tab) => {
        const { contentPagesToShow, contentPages, draggableId, title } = tab;
        if (!title && !isConvertible) {
          specificErr[`${draggableId}${nameErrK}`] = [errCodesMap['999966']];
        }
        const requiredNum = responsiveContentPageTypeDict[contentPagesToShow];
        const _amountCode = !isConvertible
          ? modulesAmountValidation(
              requiredNum,
              contentPages,
              errCodesMap['999967'] || '',
            ) || []
          : [];

        const arr = specificErr[`${draggableId}${amountErrK}`];
        specificErr[`${draggableId}${amountErrK}`] = [
          ...(arr || []),
          ..._amountCode,
        ];

        const { specificError } = !isConvertible
          ? contentImgListValidation({
              contentPages: allContentPages,
              type: EnumModuleType.ResponsiveContentTab,
              list: contentPages,
            })
          : { specificError: {} };
        Object.keys(specificError).forEach((now) => {
          const err = specificError[now] || [];
          const newK = `${draggableId}${now}`;
          const arr = specificErr[newK] || [];
          specificErr[newK] = [...(arr || []), ...err];
        });

        //  contentImgListValidation({
        //    type: EnumModuleType.ResponsiveContentCarousel,
        //    list,
        //  });
      });

      return {
        hasError: convertSpecificError(specificErr).length > 0,
        specificError: specificErr,
        generalError: [],
      };
    }
    default: {
      return {
        hasError: false,
        specificError: {},
        generalError: [],
      };
    }
  }
};

//const validateContentImg = () => {};

export const contentImgListValidation = (data) => {
  const { type, list = [], contentPages, subTitleRequired } = data;
  const specificError = {};
  const generalError = [];

  if (list.length < 1) {
    generalError.push(errCodesMap['999990']);
    specificError[errKeys[type].contentPages] = [errCodesMap['999990']];
  }
  for (const content of list) {
    const { contentPage, image, summary, subtitle, draggableId = '' } = content;
    specificError[`${draggableId}${errKeys[type].contentPageInvalid}`] = [];
    specificError[`${draggableId}${errKeys[type].contentPage}`] = [];
    specificError[`${draggableId}${errKeys[type].image}`] = [];
    specificError[`${draggableId}${errKeys[type].summary}`] = [];
    specificError[`${draggableId}${errKeys[type].subtitle}`] = [];
    // contentPageInvalid: 'contentPageInvalid',

    // console.log('contentPage', contentPage);
    // console.log('contentPages', contentPages);

    if (!(contentPage || {}).uuid) {
      specificError[`${draggableId}${errKeys[type].contentPage}`].push(
        errCodesMap['999978'],
      );
    }

    if ((contentPage || {}).uuid && contentPages) {
      const find = (contentPages || []).find(
        (i) => i.uuid === (contentPage || {}).uuid,
      );
      if (!find) {
        specificError[`${draggableId}${errKeys[type].contentPageInvalid}`].push(
          errCodesMap['999978'],
        );
      }
    }

    if (!(image || {}).uuid) {
      specificError[`${draggableId}${errKeys[type].image}`].push(
        errCodesMap['999978'],
      );
    }
    if (!summary) {
      specificError[`${draggableId}${errKeys[type].summary}`].push(
        errCodesMap['999978'],
      );
    }
    if (
      !subtitle &&
      (type === EnumModuleType.ResponsiveContentTab ||
        type === EnumModuleType.ArticleCarousel ||
        type === EnumModuleType.ResponsiveContentCarousel ||
        type === EnumModuleType.ResponsiveContentGrid ||
        subTitleRequired)
    ) {
      specificError[`${draggableId}${errKeys[type].subtitle}`].push(
        errCodesMap['999978'],
      );
    }
  }
  return { generalError, specificError };
};

const linkImgValidation = ({ data, err = {}, suffixKey = '' }) => {
  const { linkImage } = data || {};
  err[`${suffixKey}${errKeys.linkImage}`] = [];
  err[`${suffixKey}${errKeys.linkType}`] = [];
  if (!(linkImage || {}).uuid) {
    err[`${suffixKey}${errKeys.linkImage}`].push(errCodesMap['199221']);
  }

  const { result, code } = validateLink(data) || {};

  if (!result) {
    if (code) err[`${suffixKey}${errKeys.linkType}`].push(errCodesMap[code]);
  }

  return err;
};

const linkValidation = ({ data, err = {}, suffixKey = '' }) => {
  err[`${suffixKey}${errKeys.linkType}`] = [];
  const { result, code } = validateLink(data);

  if (!result) {
    if (code) err[`${suffixKey}${errKeys.linkType}`].push(errCodesMap[code]);
  }
  return err;
};

const linkModulesContentValidation = (data = []) => {
  //link module has two elements -> link and image
  //const err = new Set<number | string>();
  let _err = {};

  for (const _link of data) {
    const { draggableId } = _link || {};
    _err = linkImgValidation({
      err: _err,
      data: _link,
      suffixKey: draggableId,
    });
  }

  return {
    moduleError: _err,
    hasError: convertSpecificError(_err).length > 0,
  };
};

const modulesAmountValidation = (
  requiredBase = 1,
  data = [],
  emptyCode: number | string,
  isProduct?: boolean,
  greaterOnly?: boolean,
) => {
  //console.log()
  const err = [];
  const _code = {
    1: errCodesMap[isProduct ? '999975' : '999971'],
    2: errCodesMap[isProduct ? '104326' : '104334'],
    3: errCodesMap[isProduct ? '104327' : '104335'],
    4: errCodesMap[isProduct ? '999974' : '999970'],
    5: errCodesMap[isProduct ? '999973' : '999969'],
    6: errCodesMap[isProduct ? '999972' : '999968'],
  };
  if (data.length === 0) err.push(emptyCode || errCodesMap['104337']);
  if (greaterOnly) {
    if (data.length !== 0 && data.length < requiredBase) {
      const _c = _code[requiredBase];
      err.push(_c);
    }
  } else {
    if (data.length !== 0 && data.length % requiredBase !== 0) {
      const _c = _code[requiredBase];
      err.push(_c);
    }
  }

  return err;
};

const layerErrorKey = {
  btnLinkModule: 'btnLinkModule',
  btnText: 'btnText',
  btnTheme: 'btnTheme',
  imageLinkModule: 'imageLinkModule',
  imageImage: 'imageImage',
  text: 'text',
};
const validateImageLayer = (layer, breakpoint?) => {
  const isConvertible = breakpoint !== EPreviewSize.WIDE;
  const specificError = {
    [layerErrorKey.btnLinkModule]: [],
    [layerErrorKey.btnText]: [],
    [layerErrorKey.btnTheme]: [],
    [layerErrorKey.imageLinkModule]: [],
    [layerErrorKey.imageImage]: [],
    [layerErrorKey.text]: [],
  };

  const { layerType } = layer;
  //console.log('layerType', layerType);
  if (layerType === ELayerType.BUTTON) {
    const { linkModule } = layer;
    const { result, code } = validateLink(linkModule) || {};
    // const uuid = get(linkModule, 'uuid');
    const buttonText = get(layer, 'buttonText');
    const buttonThemeUuid = get(layer, 'buttonThemeUuid');
    //errCodesMap['104310']
    if (!result && !isConvertible) {
      specificError[layerErrorKey.btnLinkModule].push(errCodesMap[code]);
    }
    if (!buttonText && !isConvertible) {
      specificError[layerErrorKey.btnText].push(errCodesMap['104310']);
    }
    if (!buttonThemeUuid) {
      specificError[layerErrorKey.btnTheme].push(errCodesMap['104310']);
    }
  }
  if (layerType === ELayerType.IMAGE) {
    const { image, linkModule } = layer;
    const imageUuid = get(image, 'uuid');
    const { result, code } = validateLink(linkModule) || {};
    if (!imageUuid) {
      specificError[layerErrorKey.imageImage].push(errCodesMap['104310']);
    }
    if (!result) {
      specificError[layerErrorKey.imageLinkModule].push(errCodesMap[code]);
    }
  }
  if (layerType === ELayerType.TEXT) {
    // const err = get(layer, 'content.contentHasError');
    // if (err) {
    //   specificError[layerErrorKey.text].push(errCodesMap['999999']);
    // }
  }
  // console.log('specificError', specificError);
  return {
    hasError: convertSpecificError(specificError).length > 0,
    specificError: specificError,
    generalError: [],
  };
};

const validateImageEdit = (data, extraProps?) => {
  const { isPoster, breakpoint } = extraProps || {};
  const { imageLink, image, name, layers } = data;
  //validatePosterCarouselSetting;
  const errorCarouselSetting = !isPoster
    ? validateCarouselSetting(
        {
          imageLink,
          image,
          name,
        },
        { breakpoint },
      )
    : validatePosterCarouselSetting(
        {
          imageLink,
          image,
          name,
        },
        { breakpoint },
      );
  const { hasError: settingHasError } = errorCarouselSetting;
  let layerHasError = false;
  (layers || []).forEach((now) => {
    //const { draggableId } = now;
    //console.log('now', now);
    const error = validateImageLayer(now, breakpoint);
    //console.log('error', error);
    const { hasError } = error;
    if (hasError && !layerHasError) {
      layerHasError = true;
    }
  });

  return { hasError: layerHasError || settingHasError };
};

const getCurrentDisplayError = ({
  previousError,
  currentData,
  display,
  validation,
  setPDataError,
}) => {
  return _getCurrentDisplayError({
    previousError,
    currentData,
    display,
    validation,
    setPDataError,
    isContentGroup: true,
  });
};

const onContentErrorHooks = ({
  data: _data,
  isOpen: isOpen,
  display: _display,
  validationProps,
}) => {
  return _onContentErrorHooks({
    data: _data,
    isOpen: isOpen,
    display: _display,
    validation: (data) => {
      return validation(data, validationProps);
    },
    isContentGroup: true,
    stamp: null,
  });
};

const initContentBody = ({
  contentBody,
  moduleContentOrder,
  isNew,
  collapseOpen,
  collapseErrorMsgDisplay,
  moduleContentDynamicConfig,
  moduleContentStaticConfig,
}) => {
  contentBody.forEach((i, index) => {
    const _item = _.cloneDeep(i);
    const draggableId = i.draggableId || randomNumber();
    const { moduleType } = i;
    moduleContentOrder.push({ moduleType, draggableId });
    const _hasList = hasItemList.includes(moduleType);
    if (isNew && index === 0) {
      collapseOpen[draggableId] = true;
      collapseErrorMsgDisplay[draggableId] = {
        hasError: true,
        display: !isNew,
      }; //因为默认生成的就是有错误
    } else {
      collapseOpen[draggableId] = false;
      collapseErrorMsgDisplay[draggableId] = {
        hasError: false, //默认false
        display: !isNew,
      };
    }
    // console.log('_hasList', _hasList);
    if (_hasList) {
      const _listName = listPropertyName[moduleType];
      // console.log('_listName', _listName);
      if (_listName) {
        let listValue;
        if (Array.isArray(_listName)) {
          listValue = _listName.reduce((pre, key) => {
            const _re = (i[key] || []).map((o) => {
              return { ...o, draggableId: o.draggableId || randomNumber() };
            });
            return { ...pre, [key]: _re };
          }, {});
        } else {
          listValue = (i[_listName] || []).map((o) => {
            return { ...o, draggableId: o.draggableId || randomNumber() };
          });
        }
        //console.log('listValue', listValue);
        moduleContentDynamicConfig[draggableId] = listValue;
        _item.displayErrorMsg = true;
        if (moduleType === EnumModuleType.ResponsivePosterTab) {
          const listValue = (i['tabs'] || []).map((o) => {
            const posters = get(o, 'posters') || [];
            const draggableId =
              get(o, 'draggableId') || get(o, 'uuid') || randomNumber();
            const _posters = posters.map((p) => {
              const draggableId = p.draggableId || randomNumber();
              return { ...p, draggableId };
            });
            return { ...o, draggableId, posters: _posters };
            //return { ...o, draggableId: o.draggableId || randomNumber() };
          });

          moduleContentDynamicConfig[draggableId] = listValue;

          if (listValue.length > 0) {
            const itemId = get(listValue, '0.draggableId');
            _item.selectedTab = itemId;
          }
        }
        if (moduleType === EnumModuleType.ResponsiveProductTab) {
          const listValue = (i['tabs'] || []).map((o) => {
            const products = get(o, 'products') || [];
            const draggableId =
              get(o, 'draggableId') || get(o, 'uuid') || randomNumber();
            const _product = products.map((p) => {
              const { uuid } = p;
              return { ...p, draggableId: uuid };
            });
            return { ...o, draggableId, products: _product };
            //return { ...o, draggableId: o.draggableId || randomNumber() };
          });
          moduleContentDynamicConfig[draggableId] = listValue;

          if (listValue.length > 0) {
            const itemId = get(listValue, '0.draggableId');
            _item.selectedTab = itemId;
          }
        }
        if (moduleType === EnumModuleType.ResponsiveContentTab) {
          const listValue = (i['tabs'] || []).map((o) => {
            const contentPages = get(o, 'contentPages') || [];
            const draggableId =
              get(o, 'draggableId') || get(o, 'uuid') || randomNumber();
            const _contentPages = contentPages.map((p, index) => {
              //const { uuid } = p;
              const uuid = get(p, 'contentPage.uuid');
              return {
                ...p,
                draggableId: uuid ? uuid + index : randomNumber(),
              };
            });
            return { ...o, draggableId, contentPages: _contentPages };
            //return { ...o, draggableId: o.draggableId || randomNumber() };
          });
          moduleContentDynamicConfig[draggableId] = listValue;

          if (listValue.length > 0) {
            const itemId = get(listValue, '0.draggableId');
            _item.selectedTab = itemId;
          }
          // if ((i['tabs'] || []).length > 0) {
          //   const itemId = get(i, 'tabs.0.draggableId');
          //   _item.selectedTab = itemId;
          // }
        }
        delete _item[_listName];
      }
    }

    moduleContentStaticConfig[draggableId] = { ...(_item || {}), draggableId };
  });
  // console.log('contentBody', contentBody);
  //console.log('collapseErrorMsgDisplay', collapseErrorMsgDisplay);
  return contentBody;
};

const initContentError = ({
  moduleContentDynamicConfig,
  _a,
  moduleContentOrder,
  moduleContentStaticConfig,
  flag,
  validationProps,
}) => {
  for (const _o of moduleContentOrder) {
    const { draggableId } = _o;
    const _static = moduleContentStaticConfig[draggableId];
    const _dynamic = moduleContentDynamicConfig[draggableId];
    const { hasError: _e } = validation(
      {
        staticData: _static,
        dynamicData: _dynamic,
      },
      validationProps,
    );

    if (_e && !flag) {
      //已经又打开的
      _a.collapseOpen[draggableId] = true;
      _a.collapseErrorMsgDisplay[draggableId].hasError = true;
      flag = true;
      continue;
    }
    if (_e && flag) {
      _a.collapseErrorMsgDisplay[draggableId].hasError = true;
      continue;
    }
  }
};

const generateBody = ({
  moduleContentDynamicConfig,
  moduleContentOrder,
  moduleContentStaticConfig,
  validationProps,
}: any) => {
  const arr = moduleContentOrder.map((i) => {
    const { moduleType, draggableId } = i;
    const _static = moduleContentStaticConfig[draggableId] || {};
    const _hasList = hasItemList.includes(moduleType);
    const _listName = listPropertyName[moduleType];
    const _r = {
      ..._static,
    };

    if (_hasList && _listName) {
      if (Array.isArray(_listName)) {
        _listName.forEach((i) => {
          _r[i] = moduleContentDynamicConfig[draggableId][i];
        });
      } else {
        _r[_listName] = moduleContentDynamicConfig[draggableId];
      }
    }
    return _r;
  });
  const list = filterResponsiveTextEditorProps(
    arr,
    get(validationProps, 'breakpoint'),
  );
  return list;
};

const filterResponsiveTextEditorProps = (
  arr: Array<any>,
  breakpoint: string,
) => {
  if (breakpoint === EPreviewSize.WIDE) {
    return arr.map((item: any) => {
      if (item.moduleType === EnumModuleType.ResponsiveText) {
        return {
          ...item,
          content: {
            ...(item?.content || {}),
            fontSizeMultiply: 100,
          },
        };
      } else {
        return item;
      }
    });
  } else {
    return arr;
  }
};
